import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, dark = false, testId }) => (
  <div className="relative" data-testid={testId}>
    <Reveal>
      <div className="flex items-center gap-4">
        <span className="h-px w-12 bg-cafe" />
        <span
          className={`font-mono text-xs font-semibold uppercase tracking-[0.3em] ${
            dark ? "text-white/60" : "text-cafe-muted"
          }`}
        >
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        className={`mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-white" : "text-cafe-dark"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
